import React from 'react';
import { Row, Col } from 'antd';

const DashboardSection = ({ children, className = '' }) => (
  <Row className={className ? `customer-dashboard-section ${className}` : 'customer-dashboard-section'}>
    <Col span={24}>{children}</Col>
  </Row>
);

export default DashboardSection;
